import React from 'react';

import { 
  Menu, 
  X, 
  Sun, 
  Moon, 
  LayoutDashboard, 
  User,
  Users,
  UsersRound,
  ShieldUser,
  CircleUserRound, 
  BarChart3, 
  Settings, 
  TrendingUp, 
  DollarSign, 
  ShoppingCart,
  Bell,
  Search,
  Filter,
  Download,
  Upload,
  Eye,
  Edit,
  Trash2,
  Plus,
  Minus,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  Home,
  Mail,
  Phone,
  Calendar,
  Clock,
  MapPin,
  Star,
  Heart,
  Bookmark,
  Share2,
  MessageCircle,
  ThumbsUp,
  AlertCircle,
  CheckCircle,
  XCircle,
  Info,
  File,
  HelpCircle,
  LogIn,
  DoorClosedLocked,
  LoaderCircle,
  ScanFace,
  QrCode,
  UserCheck,
  List,
  RefreshCw,
  Circle
} from 'lucide-react';

import type {IconProps} from '../types';
const iconMap = {
  // Navigation
  menu: Menu,
  close: X,
  home: Home,
  loading: LoaderCircle,
  refresh: RefreshCw,
  
  // Theme
  sun: Sun,
  moon: Moon,
  
  // Dashboard
  dashboard: LayoutDashboard,
  users: Users,
  users_round: UsersRound,
  shield_user: ShieldUser,
  circle_users: CircleUserRound,
  analytics: UsersRound,
  settings: Settings,
  file: File,
  login: LogIn,
  door: DoorClosedLocked,
  
  // Charts & Stats
  trending: TrendingUp,
  dollar: DollarSign,
  shopping: ShoppingCart,
  chart: BarChart3,
  
  // Actions
  bell: Bell,
  search: Search,
  filter: Filter,
  download: Download,
  upload: Upload,
  eye: Eye,
  edit: Edit,
  trash: Trash2,
  plus: Plus,
  minus: Minus,
  check: UserCheck,
  
  // Arrows
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  
  // Communication
  mail: Mail,
  phone: Phone,
  message: MessageCircle,
  share: Share2,
  
  // Time & Location
  calendar: Calendar,
  clock: Clock,
  location: MapPin,
  
  // Social
  star: Star,
  user: User,
  heart: Heart,
  bookmark: Bookmark,
  'thumbs-up': ThumbsUp,

  //devices
  facial: ScanFace,
  qr: QrCode,
  circle: Circle,
  
  // Status
  'alert-circle': AlertCircle,
  'check-circle': CheckCircle,
  'x-circle': XCircle,
  info: Info,
  'help-circle': HelpCircle,
  'list': List,
};

export const Icon: React.FC<IconProps> = ({ 
  name, 
  className = "w-5 h-5", 
  size 
}) => {
  const IconComponent = iconMap[name as keyof typeof iconMap];
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  
  const sizeClass = size ? `w-${size} h-${size}` : className;
  
  return <IconComponent className={sizeClass} />;
};

export default Icon;